export default "__VITE_ASSET__DNLa9T46__"